export const LoadPrevPageTask = ({ listContext }) => {
    // TODO: Реалізувати завантаження попередньої сторінки
}
